import { useCallback, useReducer } from "react";
import useToggle from "../../../hook/useToggle";
import { Action } from "../../../types/reducer-action";
import AccordionContainer from "../../common/accordion-container";
import BusyButton from "../../common/busy-button";
import { DataEntryEvent } from "../../common/data-entry-reducer";
import { AddIcon, SaveIcon } from "../../common/icons";
import NewValueModal from "./new-value-modal";
import useValueListApi from "./useValueListApi";
import ValueDetailsPane from "./value-details-pane";
import ValueSearchForm from "./value-group-form";
import { ValueListContext, ValueListDispatchContext, ValueListState, useValueListDispatch, useValueListState, valueListReducer } from "./value-list-manager-context";
import ValueListTable from "./value-list-table";
import Button from "../../common/button";

export default function ValueListManager() {
  const [state, dispatch] = useReducer(valueListReducer, {} as ValueListState);

  return (
    <ValueListContext.Provider value={state}>
      <ValueListDispatchContext.Provider value={dispatch}>
        <ValueSearchPane />

        <ValueDetailsPane />
      </ValueListDispatchContext.Provider>
    </ValueListContext.Provider>
  );
}

function ValueSearchPane() {
  const { dataSet, currentValueGroup, sortedItems } = useValueListState();

  const dispatch = useValueListDispatch();

  const { sortValueList, busy } = useValueListApi();

  const { isOpen: isCreationModalOpen, toggle: toggleCreationModal } = useToggle();

  const sortable = !!currentValueGroup && currentValueGroup !== 'CITY';

  const handleNew = () => {
    dispatch(new Action(DataEntryEvent.NewForm, {
      type: currentValueGroup, // preset the group
      active: true // new value is active by default
    }));
    toggleCreationModal();
  };

  const handleSave = useCallback(() => {
    dataSet && sortedItems && sortValueList(dataSet, sortedItems)
      .then(ok => ok && dispatch(new Action(DataEntryEvent.SetStateValues, { sortedItems: undefined })));
  }, [dataSet, sortedItems]);

  return (
    <AccordionContainer title="Search Values">
      <ValueSearchForm />

      <div className="oms-row">
        <Button type="button" aria-label="Create New Value" color="primary"
          onClick={handleNew} disabled={!currentValueGroup}>
          <AddIcon /> Create New Value
        </Button>

        {sortable &&
          <BusyButton type="button" color="primary"
            onClick={handleSave} disabled={!sortedItems || sortedItems.length === 0}
            value="Save Changes" busy={busy}>
            <SaveIcon />
          </BusyButton>
        }

        <NewValueModal isOpen={isCreationModalOpen} toggle={toggleCreationModal} />
      </div>

      <ValueListTable pageSize={10} sortable={sortable} />
    </AccordionContainer>
  );
}
